import { combineReducers } from 'redux'
import user from './user.reducer'
import admin from './admin.reducer'
import common from './common.action'

export default combineReducers({
    userInfo: user,
    adminInfo: admin,
    commonStore: common
})